<template lang="pug">
  .login-box(data-testid="content-login")

    app-messages(:errorMessages="errors", :successMessages="successes")

    .login-logo
      //- b {{$store.getState('service_name')}}
      img(src="/static/images/login/logo.png", :alt="$store.getState('service_name')", :title="$store.getState('service_name')")

    .login-box-body
      //- p.login-box-msg
        small
          b Version
          |
          | {{$store.getState('service_version')}}
      form(@submit.prevent="login", data-testid="form-login")
        .form-group
          input.form-control(type='text', name="company_code", placeholder='企業コード', v-model="company_code", :maxlength="maxlengths_licenses.company_code" required, data-testid="company-code")
          //- i.fa.fa-building-o.form-control-feedback
        .form-group
          input.form-control(type='text', name="loginid", placeholder='ログインID', v-model="loginid", required :maxlength="maxlengths_users.loginid", data-testid="loginid")
          //- i.fa.fa-envelope-o.form-control-feedback
        .form-group
          input.form-control(type='password', name="word", placeholder='パスワード', v-model="word" :maxlength="maxlengths_users.word", data-testid="word")
          //- i.fa.fa-lock.form-control-feedback
        .checkbox.checkbox-rich
          label
            input(type="checkbox" v-model="isRememberMe")
            span: i.fa.fa-check.fa-lg
            | ログイン情報を保存する

        button.btn.btn-primary.btn-block(type='submit', data-testid="btn-login") ログイン

    //------------------------------------------------------------
    //- modals
    //------------------------------------------------------------
    //- パスワード変更モーダル
    form#password-edit(ref="form",@submit.prevent="editWord", novalidate)
      app-modal(v-model="isOpenPwdEditModal")
        template(slot="title") パスワード変更
        app-messages(:errorMessages="wordErrors")
        h4.text-danger パスワードの有効期限が過ぎています。
        p.text-danger パスワードを変更してください。

        .form-horizontal
          .form-group
            label.col-sm-4.control-label 現在のパスワード :
            .col-sm-7
              input.form-control(type="password" v-model="old_word" :maxlength="maxlengths_users.word")
          .form-group
            label.col-sm-4.control-label 新しいパスワード :
            .col-sm-7
              input.form-control(type="password" v-model="new_word" id="word_" @input="checkNewWord" :maxlength="maxlengths_users.word")
          .form-group
            label.col-sm-4.control-label
              | 新しいパスワード :
              br
              | （確認用）&nbsp;
            .col-sm-7
              input.form-control(type="password" v-model="new_word_conf" id="word_conf" name="new_word_conf" ref="newWord" @input="checkNewWord" :maxlength="maxlengths_users.word")
        template(slot="footer", slot-scope="{close}")
          button.btn.btn-primary(type="submit") 変更
          button.btn.btn-default(type="button" @click="close") キャンセル

</template>

<script>
import Vue from 'vue'
import AppMessages from '@/components/molecules/AppMessages'
import AppModal from '@/components/templates/AppModal'
import mixinForm from '@/mixins/form'
import qs from 'qs'
import RepositoryFactory from '@/repositories/RepositoryFactory'

const AuthRepository = RepositoryFactory.get('authority')

export default {
  name: 'Login',
  components: { AppMessages, AppModal },
  mixins: [ mixinForm ],
  data: function () {
    return {
      company_code: '',
      loginid: '',
      word: '',
      isRememberMe: false,

      old_word: '',
      new_word: '',
      new_word_conf: '',
      isOpenPwdEditModal: false, // パスワード変更モーダル
      wordErrors: [], // パスワード変更モーダル用エラーメッセージ

      // maxlengths
      maxlengths_licenses: {},
      maxlengths_users: {}
    }
  },
  created: function () {
    // データキャッシュクリア
    this.$store.commit('resetState')
    // ログイン情報の復元
    this.restoreLoginData()

    // maxlengthsの取得
    this.maxlengths_licenses = this.loadMaxlengths('Licenses')
    this.maxlengths_users = this.loadMaxlengths('Users')
  },
  mounted () {
    // desknet's NEO SSO 機能
    this.dnNEOSSO()
  },
  methods: {
    /**
     * ログイン処理
     */
    login: function () {
      // 入力チェックを行う
      if (!this.checkFormValidity()) return

      // 「0101_ログイン」処理を実行する
      const vm = this
      AuthRepository.login({
        company_code: this.company_code,
        loginid: this.loginid,
        word: this.word
      })
        .then(function (response) {
          // token保存
          const data = vm.getApiData(response).data
          const token = data.token
          // API config
          Vue.ApiAdapter.setApiToken(token)
          // store（時間がかかるので後にする）
          vm.$store.dispatch('setToken', token)
          vm.storeLoginData()

          // クエリに次のrouteがある場合、そのrouteに移動する
          const next = vm.$route.query.next
          if (next) {
            // セッションに埋まったか確認してから遷移するための値
            const oldStateU = vm.$store.state.base.u

            // 次のroute先の権限チェックに必要な情報をセッションに埋めておく
            vm.$store.commit('setInitInfo', {
              login_user: data.login_user,
              company_code: data.company_code,
              sid_corporate: data.sid_corporate
            })

            const intvl = setInterval(() => {
              if (oldStateU !== vm.$store.state.base.u) {
                vm.$router.push(qs.parse(next))
                clearInterval(intvl)
              }
            })
          }
          else {
            // 通常はトップ画面に進む
            vm.$router.push({name: 'top'})
          }
        })
        // エラー時処理
        .catch(function (error) {
          // エラーコードが4010（有効期限切れ）の場合、パスワード変更モーダルを表示する
          const appCode = error.response ? vm.getAppErrCode(error.response.data.data.message) : ''
          if (appCode === '4010') {
            vm.isOpenPwdEditModal = true
          }
          // 4010（有効期限切れ）以外の場合、エラーメッセージを表示する
          else {
            vm.errors.push(vm.setErrorMessage(error))
          }
        })
    },
    editWord: function () {
      // メッセージの初期化
      this.wordErrors = []

      if (!this.checkFormValidity()) {
        // checkFormValidity()で生成したメッセージをダイアログ内のみに表示する
        this.wordErrors = this.errors
        this.errors = []
        return
      }

      const vm = this

      // API実行
      AuthRepository.changePass({
        company_code: this.company_code,
        loginid: this.loginid,
        word: this.old_word,
        new_word: this.new_word
      })
        // 成功時処理
        .then(function () {
          // 変更したパスワードを使用してログイン処理を行う
          vm.word = vm.new_word
          vm.login()
        })
        // エラー時処理
        .catch(function (error) {
          // エラーメッセージを表示する
          vm.wordErrors.push(error.response.data.data.message)
        })
    },
    /**
     * ログイン情報の復元
     */
    restoreLoginData: function () {
      const loginData = this.$store.getters.loginData
      if (loginData.isRememberMe) {
        this.isRememberMe = loginData.isRememberMe
        this.company_code = loginData.company_code
        this.loginid = loginData.loginid
        this.word = loginData.word
      }
    },
    /**
     * ログイン情報の保存
     */
    storeLoginData: function () {
      // ログイン情報を保存する
      this.$store.commit('setLoginData', {
        isRememberMe: this.isRememberMe,
        company_code: this.isRememberMe ? this.company_code : '',
        loginid: this.isRememberMe ? this.loginid : '',
        word: this.isRememberMe ? this.word : ''
      })
    },
    /**
     * desknet's NEO SSO 機能
     */
    dnNEOSSO () {
      // SSO に必要な値が、クエリパラメータにすべて含まれている場合
      if (Object.hasOwn(this.$route.query, 'company_code') &&
        Object.hasOwn(this.$route.query, 'loginid') &&
        Object.hasOwn(this.$route.query, 'word')
      ) {
        // 入力フォームに以下の値をセットする
        this.company_code = this.$route.query.company_code
        this.loginid = this.$route.query.loginid
        this.word = this.$route.query.word
        this.isRememberMe = false
        // 「0101_ログイン」処理を実行する
        this.login()
      }
    }
  }
}
</script>

<style scoped>
  .login-box {
    margin: 10% auto; /* adminLTEのデフォルトよりも上下を開ける */
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/login/Login.vue